import { action, Action } from 'easy-peasy';
import { ArtTextStruct } from '@meitu/saas-editor-ui';
import { type FontMaterialRaw } from '@meitu/xdesign-widgets';
import { type ListStyleStruct } from '@/services/text/types';

export type IFontMaterialModel = {
    fonts: FontMaterialRaw[];
    setFonts: Action<IFontMaterialModel, FontMaterialRaw[]>;

    listStyles: ListStyleStruct[];
    setListStyles: Action<IFontMaterialModel, ListStyleStruct[]>;

    artTexts: ArtTextStruct[];
    setArtTexts: Action<IFontMaterialModel, ArtTextStruct[]>;
};

export const fontMaterialModel: IFontMaterialModel = {
    fonts: [],
    setFonts: action((state, payload) => {
        state.fonts = payload;
    }),

    listStyles: [],
    setListStyles: action((state, payload) => {
        state.listStyles = payload;
    }),
    artTexts: [],
    setArtTexts: action((state, payload) => {
        state.artTexts = payload;
    }),
};
